
<template>
  <div>
    <v-dialog v-model="dialog" scrollable max-width="500px">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Estorno</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="reversalForm">
            <v-autocomplete 
              v-model="reversal.place_id"
              label="Selecione o módulo" 
              :items="oneClient.data.attributes.modalities"
              :rules="[rules.required]" 
              prepend-icon="mdi-star" 
              item-text="name" 
              item-value="id" 
              :loading="loading"
            ></v-autocomplete>

            <v-text-field v-money="money" :rules="[rules.required, rules.notZero]" v-model="reversal.ammount_aux"
              prepend-icon="mdi-search" label="Valor" prefix="R$"></v-text-field>
            <v-textarea :rules="[rules.required]" v-model="reversal.comment" prepend-icon="mdi-search"
              label="Comentário"></v-textarea>

            <template v-if="needs_date">
              <v-dialog ref="dialog" :return-value.sync="reversal.due_date" width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on"
                    :value="new Date(reversal.due_date.substring(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR')"
                    label="Data de vencimento" prepend-icon="event" readonly :rules="[rules.required]"></v-text-field>
                </template>
                <v-date-picker v-model="reversal.due_date" color="primary" locale="pt-br" scrollable>
                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn text icon color="error" @click="modal2 = false"><v-icon>fa-times</v-icon></v-btn> -->
                  <v-spacer></v-spacer>
                  <v-btn text icon color="success"
                    @click="$refs.dialog.save(reversal.due_date)"><v-icon>fa-check</v-icon></v-btn>
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-dialog>
            </template>

          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn @click="closeDialog()" cancel></f-btn>
          <f-btn @click="submitReversal()" save></f-btn>
        </v-card-actions>
      </v-card>


    </v-dialog>

    <dialog-loading v-if="loading" :loadingText="loadingText"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';
import { VMoney } from 'v-money'

export default {
  name: 'ClientProfileReversal',
  directives: { money: VMoney },
  components: {
    SelectModality: () => import('@/components/shared/SelectModality.vue'),
  },
  data() {
    return {
      loading: false,
      loadingText: null,
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },

      dialog: true,

      reversal: {
        ammount: '0.00',
        ammount_aux: '0.00',
        origin_id: null,
        destination_id: null,
        client_id: null,
        due_date: null,
        comment: 'Estorno de pagamento para o cliente.',
        payment_description: 'Estorno',
        place_id: null
      },
      rules: {
        required: v => !!v || 'Campo é necessário',
        notZeroPercentage: v => (!!v && v != '0.00' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
        notZero: v => v != '0.00' || 'Não pode ser zero',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 11) || 'CPF deve ser completo',
      },
    }
  },
  methods: {
    submitReversal() {
      if (this.$refs.reversalForm.validate()) {
        const c = confirm('Salvar estorno?')

        if (c) {
          this.loading = true
          this.loadingText = 'Salvando'
          this.reversal.client_id = this.oneClient.data.id
          this.reversal.ammount = this.reversal.ammount_aux.replace(/,/g, '')
          Api.Financial.createReversal(this.reversal).then(r => r.data).then(r => {
            this.addNotification({type: 'success', msg: 'Criado com sucesso'})
            this.$emit('done')
          }).catch(err => {
            this.addNotification({type: 'error', msg: err})
          }).finally(() => {
            setTimeout(() => {
              this.loading = false
              this.loadingText = null
            }, 800);
          })
        }
      }
    },
    closeDialog() {
      this.reversal = {}
      this.dialog = false
    },
  },
  computed: {
    needs_date() {
      if (this.oneClient) {
        // Caso o cliente não possua bônus de credito. 
        // Então o valor do estorno deve ser gerado em uma fatura, descrevendo a fatura como estorno de pagamento;
        // Caso o cliente possua bônus de credito, mas o valor do estorno é maior do que o bônus. 
        // Então o bônus é abatido e o restante é gerado em fatura;
      }

      return false
    },
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  watch: {
    dialog(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        this.$emit('close')
      }
    }
  },
}
</script>
